import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { authHeaders, axiosInstance } from "../../../utils/helper";
import { apiUrlB2B } from "../../../utils/constants";

const initialState = {
  data: [],
  loading: false,
  totalPages: 0,
  total: 0,
  limit: 0,
  page: 0
};

export const getListMenu = createAsyncThunk("getListMenu", async (params) => {
  const res = await axiosInstance.get(`${apiUrlB2B}menu-ufoodx`, { params, ...authHeaders() });
  const data = await res?.data?.data;
  return {
    data: data?.list,
    totalPages: Number(data?.totalPage),
    total: Number(data?.total),
    limit: Number(data?.limit),
    page: Number(data?.page)
  };
});

const listMenu = createSlice({
  name: "menu",
  initialState,
  reducers: {
    setlistMenu: (state, action) => {
      return { ...state, ...action.payload };
    },
    clearlistMenu: () => {
      return initialState;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListMenu.pending, (state) => {
        state.loading = true;
      })
      .addCase(getListMenu.fulfilled, (state, action) => {
        state.loading = false;

        if (action.payload.page === 1) {
          state.data = action.payload.data;
        } else {
          state.data = [...state.data, ...action.payload.data];
        }

        state.totalPages = action.payload.totalPages;
        state.total = action.payload.total;
        state.limit = action.payload.limit;
        state.page = action.payload.page;
      })
			.addCase(getListMenu.rejected, (state) => {
				state.loading = false;
			});
  }
});

// Export actions and reducer
export const { setlistMenu, clearlistMenu } = listMenu.actions;
export default listMenu.reducer;
